import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import helpersTime from "../../../../helpers/time";
import helpersNumber from "../../../../helpers/numbers";
import StateSiteUserAdvertiser from "../StateSiteUserAdvertiser";

export default function AllSiteUserAdvertiser() {
  const params = useParams();
  const userID = params.userID;

  const [allSiteUserAdvertiserUsers, setAllSiteUserAdvertiserUsers] = useState(
    []
  );

  useEffect(() => {
    getAllSiteUserAdvertiser();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllSiteUserAdvertiser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllSiteUserAdvertiser =
      await sendRequestGetAllSiteUserAdvertiser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllSiteUserAdvertiser) {
      return;
    }

    setAllSiteUserAdvertiserUsers(resultSendRequestGetAllSiteUserAdvertiser);
  };

  const sendRequestGetAllSiteUserAdvertiser = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/site-user-advertiser/user/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const generateTableAllSiteUserAdvertiserUsers = () => {
    return (
      <div className="table-responsive">
        <table className="table table-hilite tbl-td-white-space m-0">
          <thead>
            <tr>
              <td>#</td>
              <td>شماره</td>
              <td>شماره کاربر</td>
              <td>سایت</td>
              <td>حالت</td>
              <td>تاریخ درج</td>
              <td>تاریخ آخرین بروزرسانی</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>
            {allSiteUserAdvertiserUsers.map((siteUserAdvertiserUser, index) => {
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{siteUserAdvertiserUser.sua_id}</td>
                  <td>{siteUserAdvertiserUser.sua_user_id}</td>
                  <td>
                    {
                      <>
                        <span className="pl-2">
                          {siteUserAdvertiserUser.sua_site_url}
                        </span>
                        <a
                          className="btn btn-primary"
                          target="_blank"
                          href={siteUserAdvertiserUser.sua_site_url}
                        >
                          <i className="fa fa-link"></i>
                        </a>
                      </>
                    }
                  </td>

                  <td>{siteUserAdvertiserUser.sua_state}</td>
                  <td>
                    {helpersNumber.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        siteUserAdvertiserUser.sua_created_at
                      ) +
                        " " +
                        siteUserAdvertiserUser.sua_created_at.split(" ")[1]
                    )}
                  </td>
                  <td>
                    {helpersNumber.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        siteUserAdvertiserUser.sua_updated_at
                      ) +
                        " " +
                        siteUserAdvertiserUser.sua_updated_at.split(" ")[1]
                    )}
                  </td>
                  <td>
                    <Link
                      to={`/user/manage/site-advertiser/${siteUserAdvertiserUser.sua_id}`}
                      className="btn btn-info"
                    >
                      <i className="fa fa-info"></i>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  سایت های تبلیغ دهنده کاربر
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="text-white"
                  to={`/user/show-info-user/${userID}`}
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>

              <div>
                {allSiteUserAdvertiserUsers.length == 0 ? (
                  <></>
                ) : (
                  generateTableAllSiteUserAdvertiserUsers()
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
